export default "/_next/static/media/domains-hd.74840020ee5e257b13463f024858aeea.png";